import React, { useEffect } from "react";
import { Modal, notification, Button, Form, Row, Col } from "antd";
import "../Modal/AllUserTableModal.css";
import { updateAllUser } from "../../util/APIUtils";

const AllModalComponent = ({ visible, onClose, selectedItem, onUpdate }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedItem) {
      form.setFieldsValue({
        recordId: selectedItem.recordId,
        name: selectedItem.name,
        surname: selectedItem.surname,
        email: selectedItem.email,
        tckn: selectedItem.tckn,
        phoneNumber: selectedItem.phoneNumber,
        activityArea: selectedItem.activityArea,
        workAddress: selectedItem.workAddress,
        homeAddress: selectedItem.homeAddress,
        createdAt: selectedItem.createdAt,
        updatedAt: selectedItem.updatedAt,
      });
    }
  }, [visible, selectedItem]);

  const handleUpdate = () => {
    form.validateFields().then((values) => {
      const updatedItem = {
        recordId: selectedItem.recordId,
        email: values.email,
      };

      updateAllUser(updatedItem, updatedItem.recordId)
        .then(() => {
          notification.success({
            message: "Başarılı",
            description: "Kullanıcı başarıyla güncellendi.",
          });
          onClose();
          onUpdate(updatedItem);
        })
        .catch((error) => {
          console.error("Güncelleme hatası:", error);
          notification.error({
            message: "Hata",
            description: "Kullanıcı güncellenirken bir hata oluştu.",
          });
        });
    });
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div>
      {visible && (
        <div className="modal">
          <Modal
            title={
              selectedItem && (
                <p>
                  <span style={{ fontWeight: "bold" }}>
                    {selectedItem.tckn}
                  </span>{" "}
                  -TCKN Numaralı Müşteri İçin İşlem Yapmaktasınız
                </p>
              )
            }
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                İptal
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleUpdate}
                style={{ background: "	#2196F3", borderColor: "#2196F3" }}
              >
                Kaydet
              </Button>,
            ]}
            width={400}
          >
            <Form form={form}>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="İsim"
                    name="name"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ marginBottom: "8px" }}
                  >
                    <input className="task-input wide-input" type="text" disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Soyisim"
                    name="surname"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ marginBottom: "8px" }}
                  >
                    <input className="task-input wide-input" type="text" disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="E-mail"
                    name="email"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ marginBottom: "8px" }}
                  >
                    <input className="task-input wide-input" type="text" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Telefon Numarasi"
                    name="phoneNumber"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    style={{ marginBottom: "1px" }}
                  >
                    <input className="task-input wide-input" type="text" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default AllModalComponent;



// WEBPACK FOOTER //
// ./src/component/Modal/AllUserTableModal.js